// src/components/Pages/Profile.js
import React, { useMemo } from "react";
import ProfileSettings from "./ProfileSettings";
import { useAuth } from "../../contexts/AuthContext";
import { splitName } from "../../utils/name";

const Profile = () => {
  const { user, authFetch, setUser } = useAuth();

  const parts = useMemo(() => splitName(user?.name || ""), [user?.name]);

  const initialUser = useMemo(
    () => ({
      id: user?.id || "",
      firstName: parts.firstName || "",
      middleName: parts.middleName || "",
      lastName: parts.lastName || "",
      email: user?.email || "",
      phone: user?.phone || "",
      role: user?.role || "Staff",
      avatarUrl: user?.avatarUrl || "",
    }),
    [
      user?.id,
      user?.email,
      user?.phone,
      user?.role,
      user?.avatarUrl,
      parts.firstName,
      parts.middleName,
      parts.lastName,
    ]
  );

  const onSave = async (payload) => {
    const hasFile = payload?.avatarFile instanceof File;

    const safe = { ...(payload || {}) };
    delete safe.role;

    const options = {
      method: "PUT",
    };

    if (hasFile) {
      const formData = new FormData();
      formData.append("firstName", safe.firstName || "");
      formData.append("middleName", safe.middleName || "");
      formData.append("lastName", safe.lastName || "");
      formData.append("email", safe.email || "");
      formData.append("phone", safe.phone || "");

      if (safe.currentPassword) {
        formData.append("currentPassword", safe.currentPassword);
      }
      if (safe.newPassword) {
        formData.append("newPassword", safe.newPassword);
      }
      if (safe.confirmPassword) {
        formData.append("confirmPassword", safe.confirmPassword);
      }

      formData.append("avatar", safe.avatarFile);
      options.body = formData;
    } else {
      const {
        avatarFile,
        avatarUrl,
        ...rest
      } = safe;

      options.headers = {
        "Content-Type": "application/json",
      };
      options.body = JSON.stringify(rest);
    }

    const res = await authFetch(`/users/${user.id}/profile`, options);
    const data = await res.json().catch(() => ({}));

    if (!res.ok) {
      throw new Error(data.message || "Failed to update profile");
    }

    if (data.user) {
      const updatedUser = {
        ...user,
        id: data.user.id ?? user.id,
        name: data.user.name ?? user.name,
        email: data.user.email ?? user.email,
        role: data.user.role ?? user.role,
        phone: data.user.phone ?? user.phone,
        avatarUrl: data.user.avatarUrl ?? user.avatarUrl ?? "",
      };

      setUser(updatedUser);
      localStorage.setItem("admin_user", JSON.stringify(updatedUser));
    }
  };

  return (
    <ProfileSettings
      key={`${initialUser.id}-${initialUser.email}-${initialUser.avatarUrl}`}
      initialUser={initialUser}
      onSave={onSave}
      onCancel={() => {}}
      roleReadOnly={true}
    />
  );
};

export default Profile;